<script setup lang="ts">
import { RoleGroups } from '@/constants/Roles';
import Routes from '@/constants/Routes';
import { t } from '@/i18n';
import { ref, onMounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { DxTabs, type DxTabsTypes } from 'devextreme-vue/tabs';
import Icons from '@/constants/Icons';
import { svgIcon } from '@/helpers/iconHelpers';

definePage({
  name: 'MaintenanceRoot',
  meta: {
    title: 'maintenance.title',
    roles: RoleGroups.Maintenance
  }
});

const router = useRouter();
const route = useRoute();
const selectedItem = ref<number>();
// Getters, so the tabs read the current locale.
const items = [
  { get text(): string { return t('maintenance.tabs.stations'); }, icon: svgIcon(Icons.EarthEurope), routeName: Routes.Maintenance.Stations, path: '/maintenance/stations' },
  { get text(): string { return t('maintenance.tabs.carriers'); }, icon: svgIcon(Icons.Plane), routeName: Routes.Maintenance.Carriers, path: '/maintenance/carriers' },
  { get text(): string { return t('maintenance.tabs.slas'); }, icon: svgIcon(Icons.FileContract), routeName: Routes.Maintenance.Sla, path: '/maintenance/slas' },
  { get text(): string { return t('maintenance.tabs.roles'); }, icon: svgIcon(Icons.Users), routeName: Routes.Maintenance.Roles, path: '/maintenance/roles' },
  { get text(): string { return t('maintenance.tabs.users'); }, icon: svgIcon(Icons.UserGear), routeName: Routes.Maintenance.Users, path: '/maintenance/users' },
  { get text(): string { return t('maintenance.tabs.locations'); }, icon: svgIcon(Icons.CircleLocationArrow), routeName: Routes.Maintenance.Locations, path: '/maintenance/locations' },
  { get text(): string { return t('maintenance.tabs.categories'); }, icon: svgIcon(Icons.FilterList), routeName: Routes.Maintenance.Categories, path: '/maintenance/categories' },
  { get text(): string { return t('maintenance.tabs.customers'); }, icon: svgIcon(Icons.UserTag), routeName: Routes.Maintenance.Customers, path: '/maintenance/customers' }
];

async function tabItemClick(e: DxTabsTypes.ItemClickEvent): Promise<void> {
  await router.push({ name: e.itemData.routeName });
}

async function updateSelection(): Promise<void> {
  const item = items.find(x => route.matched.some(r => r.path.toLowerCase().startsWith(x.path.toLowerCase())));
  if (item) {
    selectedItem.value = items.indexOf(item);
  }
}

onMounted(updateSelection);

watch(route, updateSelection);
</script>

<template>
  <div class="py-2 px-3">
    <h5 class="m-0">{{ $t('maintenance.title') }}</h5>
    <small class="text-body-secondary">{{ $t('maintenance.subtitle') }}</small>
  </div>
  <div>
    <DxTabs v-model:selected-index="selectedItem" :data-source="items" :scroll-by-content="true" :show-nav-buttons="true"
        width="100vw" @item-click="tabItemClick" />
  </div>
  <div class="py-2 px-3 vw-100">
    <RouterView />
  </div>
</template>

<style scoped>

</style>